import { createSlice } from "@reduxjs/toolkit";

// 初期状態
const initialState = {
  isAudioEnabled: false, // デフォルトはミュート状態
};

// Audio管理用のslice
const audioSlice = createSlice({
  name: "audio",
  initialState,
  reducers: {
    toggleAudio: (state) => {
      state.isAudioEnabled = !state.isAudioEnabled;
    },
    setAudioEnabled: (state, action) => {
      state.isAudioEnabled = action.payload;
    },
  },
});

// Actions
export const { toggleAudio, setAudioEnabled } = audioSlice.actions;

// Selectors
export const selectIsAudioEnabled = (state) => state.audio.isAudioEnabled;

// Reducer
export default audioSlice.reducer;
